/**
 * Reddit Pixel Tracking Utility
 * Tracks page visits only on public pages
 */

/**
 * List of public page paths where Reddit Pixel should track
 */
const PUBLIC_PAGES = [
  '/',
  '/pricing',
  '/features',
  '/faqs',
  '/about',
  '/blog',
  '/prosperia-ai',
  '/pwa-welcome',
  '/privacy',
  '/terms',
  '/eula',
  '/cookies',
  // Feature detail pages
  '/features/estimates-invoices',
  '/features/client-management',
  '/features/job-tracking',
  '/features/employee-management',
  '/features/mobile-app',
  '/features/payment-processing',
  '/features/embeddable-widgets',
  '/features/scheduling-calendar',
  '/features/automations',
  '/features/file-management',
  '/features/ai-powered-tools',
  '/features/site-analysis-tools',
  '/features/services-packages',
  '/features/expense-management',
  '/features/reports-analytics'
]

/**
 * Check if the current path is a public page
 * @param {string} pathname - Current pathname
 * @returns {boolean}
 */
export const isPublicPage = (pathname) => {
  // Check exact matches
  if (PUBLIC_PAGES.includes(pathname)) {
    return true
  }
  
  // Check if it's a public route (starts with /public/)
  if (pathname.startsWith('/public/')) {
    return true
  }
  
  // Check if it's a payment success page
  if (pathname.startsWith('/payment/success')) {
    return true
  }
  
  return false
}

/**
 * Track a page visit on Reddit Pixel
 * Only tracks if on a public page
 * @param {string} pathname - Current pathname
 */
export const trackRedditPageVisit = (pathname) => {
  // Only track on public pages
  if (!isPublicPage(pathname)) {
    return
  }
  
  // Check if Reddit Pixel is loaded
  if (typeof window !== 'undefined' && window.rdt) {
    try {
      window.rdt('track', 'PageVisit')
    } catch (error) {
      console.error('Error tracking Reddit Pixel PageVisit:', error)
    }
  }
}

/**
 * Initialize Reddit Pixel with advanced matching (optional)
 * This can be called when user information is available
 * @param {object} matchKeys - Advanced matching keys (email, phoneNumber, externalId, etc.)
 */
export const initRedditPixelWithMatching = (matchKeys = {}) => {
  if (typeof window !== 'undefined' && window.rdt) {
    try {
      // Only include non-empty match keys
      const filteredKeys = Object.entries(matchKeys).reduce((acc, [key, value]) => {
        if (value && value.trim() !== '') {
          acc[key] = value
        }
        return acc
      }, {})
      
      if (Object.keys(filteredKeys).length > 0) {
        window.rdt('init', 'a2_i0fqeq7dvwn1', filteredKeys)
      }
    } catch (error) {
      console.error('Error initializing Reddit Pixel with matching:', error)
    }
  }
}

